import React, { FC } from 'react';
import financeDepositStyles from './financeDepositStyles';
import Rate from '../../../../../presentational/financeElements/rate/Rate';
import { RateTypes } from '../../../../../../enum/RateTypes';
import Price from '../../../../../../../gqlCommon/components/presentation/Price';
import { PriceDisplayType } from '../../../../../../../../../common/enum/PriceDisplayType';

export interface IFinanceDepositProps {
  deposit: number;
  currency: string;
}

const FinanceDeposit: FC<IFinanceDepositProps> = ({ deposit, currency }) => {
  const style = financeDepositStyles();

  return (
    <Rate
      labelId={RateTypes.UPFRONT_PAYMENT}
      value={
        <Price
          data-test={'price:footer_cash_deposit'}
          price={deposit}
          currency={currency}
          className={style.price}
          priceDisplayType={PriceDisplayType.PRIMARY}
        />
      }
    />
  );
};

export default FinanceDeposit;
